import { getCurrentUser } from "aws-amplify/auth";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import ForgotPassword from "../../components/Onboarding/ForgotPassword";
import { SignInWithRoute } from "../../components/Onboarding/SignIn";
import { SignUpWithRoute } from "../../components/Onboarding/SignUp";
import { LOGIN_ROUTE, REGISTRATION_ROUTE } from "../../constants/routing-constants";

export type AuthState = "signIn" | "signUp" | "signedIn" | "forgotPassword" | "loading";

export interface AuthPieceProps {
  authState?: AuthState;
  onStateChange?: (state: AuthState, data?: any) => void;
  onAuthEvent?: (type: string, data: { type: string; data: string }) => void;
}

export default function withAuthentication<Props>(Component: React.ComponentType<Props>): React.ComponentType<Props> {
  class WithAuthentication extends React.Component<
    Props & AuthPieceProps & RouteComponentProps,
    { authState: AuthState; error: string | null }
  > {
    state = {
      authState: "loading" as AuthState,
      error: null as string | null,
    };

    handleStateChange = (newState: AuthState, _data?: any) => {
      this.setState({ authState: newState, error: null });
    };

    handleAuthEvent = (_type: string, data: { type: string; data: string }) => {
      if (data.type === "error") {
        this.setState({ error: data.data });
      }
    };

    async componentDidMount() {
      try {
        await getCurrentUser();
        this.setState({ authState: "signedIn" });
      } catch (error) {
        if (window.location.pathname === REGISTRATION_ROUTE) {
          this.setState({ authState: "signUp" });
        } else {
          this.setState({ authState: "signIn" });
          this.props.history.push(LOGIN_ROUTE);
        }
      }
    }

    render() {
      const { authState, error } = this.state;

      if (authState === "loading") {
        return null;
      }

      return (
        <>
          {error && (
            <div style={{ color: "red", padding: "10px", textAlign: "center", background: "#fff2f0" }}>{error}</div>
          )}
          <SignInWithRoute
            override="SignIn"
            authState={authState}
            onStateChange={this.handleStateChange}
            onAuthEvent={this.handleAuthEvent}
          />
          <SignUpWithRoute
            override="SignUp"
            authState={authState}
            onStateChange={this.handleStateChange}
            onAuthEvent={this.handleAuthEvent}
          />
          <ForgotPassword
            authState={authState}
            onStateChange={this.handleStateChange}
            onAuthEvent={this.handleAuthEvent}
          />
          {authState === "signedIn" && <Component {...this.props} />}
        </>
      );
    }
  }

  const WithAuthenticationDecorated = withRouter(WithAuthentication);

  return (props: any) => {
    return <WithAuthenticationDecorated {...props} />;
  };
}
